import { DateUtils } from 'react-day-picker';
export var isRange = function (selectedDays) {
    return !!selectedDays && Array.isArray(selectedDays);
};
export var isToday = function (date) { return DateUtils.isSameDay(date, new Date()); };
var isDaySelected = function (date, selectedDays, range) {
    return isRange(selectedDays)
        ? DateUtils.isDayInRange(date, range)
        : DateUtils.isSameDay(date, selectedDays);
};
var isSameDay = function (day1, day2) { return (!day1 || !day2 ? false : DateUtils.isSameDay(day1, day2)); };
var isStartDayOfRange = function (date, range) {
    return isSameDay(range.from, date);
};
var isEndDayOfRange = function (date, range) {
    return isSameDay(range.to, date);
};
export var getSelectionType = function (date, selectedDays) {
    if (!isRange(selectedDays)) {
        return DateUtils.isSameDay(date, selectedDays)
            ? 'single'
            : undefined;
    }
    var range = selectedDays[1];
    if (isStartDayOfRange(date, range) && isEndDayOfRange(date, range)) {
        return isDaySelected(date, selectedDays, range) ? 'single' : undefined;
    }
    if (isStartDayOfRange(date, range))
        return 'start';
    if (isEndDayOfRange(date, range))
        return 'end';
    return isDaySelected(date, selectedDays, range) ? 'between' : undefined;
};
//# sourceMappingURL=utils.js.map